export const isDev = process.env.NODE_ENV === 'development'
export const BASE_URL = isDev ? null : process.env.REACT_APP_API_ENDPOINT

export const LINK_PROCEDURE =
    'https://docs.google.com/spreadsheets/d/1IKnTNfCCFVlMZzxOhCcwikKXr0TW4NoXgo2Nu9ST3Lg/edit?ts=5ea9b758#gid=404932548'
export const LINK_ACTIVE_RECRUITMENT =
    'https://docs.google.com/spreadsheets/d/1ljNW5TnuR_YjNJPDlPJ3pxw4nwzKVoIthA4S453VIjM/edit#gid=1231716815'
